import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  //selector: 'dialog-content-example-dialog',
  selector: 'needs-kit-modal',
  standalone : true,
  templateUrl: 'needskit.modal.html',
  imports: [MatDialogModule]
})
export class NeedsKitModal { }
